export default {
    // commun
    global: {
        validate: 'Valider',
        save: 'Enregistrer',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        yes: 'oui',
        no: 'non',
        connexionError: 'Erreur de communication'
    },
    // partie principale
    main: {
        title: 'COCTURACHEF',
        noOven: 'Aucun four n\'est sélectionné',
        noOvenMessage: 'Pour ajouter et/ou sélectionner un four, rendez-vous dans les réglages',
        version: 'V 1.0'
    },
    // partie chauffe
    heat: {
        title: 'Préchauffe',
        start_confirm_title: 'Confirmer le démarrage de la chauffe',
        stop_confirm_title: 'Confirmer l\'arrêt de la chauffe',
        start_heating: 'Lancer la chauffe',
        stop_heating: 'Arréter la chauffe'
    },
    // partie minuteur
    timer: {
        title: 'Minuterie'
    },
    // partie ventilation
    ventil: {
        title: 'Ventilation',
    },
    // partie réglages
    settings: {
        title: 'Réglages',
        oven_select: 'Sélection du four',
        add_oven: 'Ajouter un four',
        lang_select: 'Sélection de la langue',
        ovenAddEdit: {
            titleAdd: 'Ajouter un four',
            titleEdit: 'Éditer les informations du four',
            name: 'Nom',
            ip: 'Adresse IP',
            key: 'Clé d\'authentification',
            remove: 'Supprimer',
            removeConfirmTitle: 'Suppression du four',
            removeConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce four ?'
        }
    },
    // partie stockage (vuex)
    store: {
        addOven_alreadyExists: 'Un four avec la même adresse IP est déjà enregistré',
        noOvenOnline: 'La communication avec le four n\'est pas configurée'
    },
    // partie validation de formulaire
    form_validation: {
        messages: {
            _default: 'Valeur incorrect',
            required: 'Il ne faut pas laisser vide ce champ',
            min: 'La valeur de ce champ est trop petite',
            ip: 'L\'adresse IP n\'est pas correcte'
        },
        custom: {
            ip: {
                required: 'Il faut entrer l\'adresse IP du four'
            }
        }
    }

}
